define("shared/types/fabric/index", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.FABRIC_TEXTBOX_ATTRS = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  /*
   * This file extends types from the @types/fabric package.
   * {@link} https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/fabric/fabric-impl.d.ts
   * {@link} http://fabricjs.com/docs/fabric.html
   */
  const FABRIC_TEXTBOX_ATTRS = ['top', 'left', 'fontSize', 'width', 'height'];
  _exports.FABRIC_TEXTBOX_ATTRS = FABRIC_TEXTBOX_ATTRS;
});